import * as ls from "local-storage";

export const BrowserSettingsKey = "gc_shop_browser_settings";

export interface IBrowserSettings {
  userHasCollapsedSideBar: boolean;
  sidebarIsHovered: boolean; // Why would this not just be React state???
  jobsTableView: boolean;
}

export const DEFAULT_BROWSER_SETTINGS: IBrowserSettings = {
  userHasCollapsedSideBar: false,
  sidebarIsHovered: false,
  jobsTableView: true,
};

export const getBrowserSettings = (): IBrowserSettings =>
  ls.get<IBrowserSettings>(BrowserSettingsKey) || DEFAULT_BROWSER_SETTINGS;

export const saveBrowserSettings = (settings: Partial<IBrowserSettings>): void => {
  const currentSettings = getBrowserSettings();
  const newSettings = { ...currentSettings, ...settings };
  ls.set<IBrowserSettings>(BrowserSettingsKey, newSettings);
};
